import { AppsFlyerEventAdapter } from './adapters/appsflyer.adapter';
import { AmplitudeAdapter } from './adapters/amplitude.adapter';
import { GoogleTagManagerAdapter } from './adapters/google.adapter';

import { UtmsResource } from '@infra/utms';
import { QueryParamsResource } from '@infra/query-params';
import { PixelResource } from '@infra/pixel';

import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { EventTrackerAdapter } from './event-tracker.adapter';
import { IEventTrackerStrategyResource } from './event-tracker-strategy.types';
import { Injectable } from '@angular/core';
import { DeviceStore } from '@app/store/device';
import { DataLayerAdapter } from './adapters/datalayer.adapter';
import { BrowserStore } from '@app/store/browser';

export type EventType = 'amplitude' | 'appsflyer' | 'tagmanager' | 'datalayer';

@Injectable({ providedIn: 'root' })
export class EventTrackerStrategyResource implements IEventTrackerStrategyResource {
  constructor(
    private utmsResource: UtmsResource,
    private queryParamsResource: QueryParamsResource,
    private gtmResource: GoogleTagManagerService,
    private pixelResource: PixelResource,
    private browserStore: BrowserStore,
    private deviceStore: DeviceStore,
  ) {}

  create(eventType: EventType): EventTrackerAdapter {
    switch (eventType) {
      case 'amplitude':
        return new AmplitudeAdapter(this.deviceStore);
      case 'appsflyer':
        return new AppsFlyerEventAdapter(this.utmsResource);
      case 'tagmanager':
        return new GoogleTagManagerAdapter(this.queryParamsResource, this.gtmResource, this.pixelResource);
      case 'datalayer':
        return new DataLayerAdapter(this.browserStore);
      default:
        throw Error('Tracker not implemented');
    }
  }
}
